import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/BaseComponents/Loader';
import './Alerts.scss';
import {
  changeShowAlertTestResultModalVisibility,
  setStaffAlerts,
  setIsStaffAlertsLoading,
  setStaffAlertsError
} from '../../store/alertsSlice';
import ShowBiomarkersTestResultsModal from '../../components/Alerts/ShowBiomarkersTestResultsModal';
import { RootState } from '../../store/store';
import { getStaffAlerts } from '../../api/staff';
import AlertsTable from '../../components/Alerts/AlertsTable';
import { BiomarkerResultType } from '../../types/apiGeneratedTypes';
import { toast } from 'react-toastify';

const Alerts = () => {
  const dispatch = useDispatch();

  const {
    isAlertTestResultModalVisible,
    selectedTestResultId,
    selectedTestResultMemberId,
    isStaffAlertsLoading,
    staffAlertsError
  } = useSelector((state: RootState) => state.alerts);


  const fetchStaffAlerts = useCallback(async () => {
    try {
      dispatch(setIsStaffAlertsLoading(true));
      dispatch(setStaffAlertsError(null));
      const resp = await getStaffAlerts();
      dispatch(setStaffAlerts(resp.alerts));
    } catch (error: any) {
      console.error('Error fetching staff alerts:', error);
      const errorMessage = error.message || 'Failed to fetch staff alerts';
      dispatch(setStaffAlertsError(errorMessage));
      toast.error(errorMessage);
    } finally {
      dispatch(setIsStaffAlertsLoading(false));
    }
  }, [dispatch]);

  useEffect(() => {
    fetchStaffAlerts();
  }, [fetchStaffAlerts]);

  if (isStaffAlertsLoading) return <Loader />;
  
  
  if (staffAlertsError) {
    return (
      <div className='alerts-page-container page-container'>
        <div className='error-container'>
          <h3>Error loading staff alerts</h3>
          <p>{staffAlertsError}</p>
          <button 
            onClick={fetchStaffAlerts}
            className='retry-button'
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className='alerts-page-container page-container'>
      <AlertsTable />
      {isAlertTestResultModalVisible && (
        <ShowBiomarkersTestResultsModal
          isOpen={isAlertTestResultModalVisible}
          onClose={() =>
            dispatch(changeShowAlertTestResultModalVisibility(false))
          }
          resultsType={BiomarkerResultType.UNPROCESSED}
          appointmentId={selectedTestResultId!}
          member_id={selectedTestResultMemberId!}
        />
      )}
    </div>
  );
};

export default Alerts;
